// Generated by Melange

import EmptyStateModuleCss from "./emptyState.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as LucideReact from "../lucideReact/lucideReact.jsx";
import * as Shared__H2 from "./h2.jsx";
import * as LucideReact$1 from "lucide-react";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const css = EmptyStateModuleCss;

function EmptyState(Props) {
  let iconOpt = Props.icon;
  let message = Props.message;
  const icon = iconOpt !== undefined ? Caml_option.valFromOption(iconOpt) : JsxRuntime.jsx(LucideReact$1.EarOff, Curry._4(LucideReact.EarOff.makeProps, undefined, undefined, undefined, undefined));
  return JsxRuntime.jsxs("div", {
    children: [
      React.cloneElement(icon, {
        className: css.icon
      }),
      JsxRuntime.jsx(Shared__H2.make, {
        children: message,
        className: css.text
      })
    ],
    className: css.root
  });
}

const make = EmptyState;

export {
  make,
}
/* css Not a pure module */
